var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDrawerProjects(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.4167 9.08331H2.58333V5.41665C2.58333 4.91156 2.99492 4.49998 3.5 4.49998H4.41667V5.41665C4.41667 5.92081 4.82917 6.33331 5.33333 6.33331C5.8375 6.33331 6.25 5.92081 6.25 5.41665V4.49998H11.75V5.41665C11.75 5.92081 12.1625 6.33331 12.6667 6.33331C13.1708 6.33331 13.5833 5.92081 13.5833 5.41665V4.49998H14.5C15.0051 4.49998 15.4167 4.91156 15.4167 5.41665V9.08331ZM12.6667 14.5833H9C8.49583 14.5833 8.08333 14.1708 8.08333 13.6666C8.08333 13.1625 8.49583 12.75 9 12.75H12.6667C13.1708 12.75 13.5833 13.1625 13.5833 13.6666C13.5833 14.1708 13.1708 14.5833 12.6667 14.5833ZM5.33333 14.5833C4.82917 14.5833 4.41667 14.1708 4.41667 13.6666C4.41667 13.1625 4.82917 12.75 5.33333 12.75C5.8375 12.75 6.25 13.1625 6.25 13.6666C6.25 14.1708 5.8375 14.5833 5.33333 14.5833ZM14.5 2.66665H13.5833V1.74998C13.5833 1.24581 13.1708 0.833313 12.6667 0.833313C12.1625 0.833313 11.75 1.24581 11.75 1.74998V2.66665H6.25V1.74998C6.25 1.24581 5.8375 0.833313 5.33333 0.833313C4.82917 0.833313 4.41667 1.24581 4.41667 1.74998V2.66665H3.5C1.98383 2.66665 0.75 3.90048 0.75 5.41665V16.4166C0.75 17.9328 1.98383 19.1666 3.5 19.1666H14.5C16.0162 19.1666 17.25 17.9328 17.25 16.4166V5.41665C17.25 3.90048 16.0162 2.66665 14.5 2.66665Z",
    fill: "#335C75"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrawerProjects);
export default __webpack_public_path__ + "static/media/DrawerProjects.7d15af9d03364a9edef8ad5472154053.svg";
export { ForwardRef as ReactComponent };